// import React from 'react';
// import parse from 'html-react-parser';
// import VideoModal from '../VideoModal';
// import { Link } from 'react-router-dom';

import { useEffect, useState } from "react";
import "./Hero.scss";

// export default function Hero({
//   title,
//   subTitle,
//   bgUrl,
//   imgUrl,
//   videoBtnText,
//   videoUrl,
//   infoList,
//   btnText,
//   btnUrl,
// }) {
//   console.log(bgUrl,"bgUrl");
  
//   return (
//     <section className="cs_hero cs_style_1">
//       <div
//         className="cs_hero_wrap cs_bg_filed"
//         style={{ backgroundImage: `url(${bgUrl})` }}
//         >
//         <div className="container">
//           <div className="cs_hero_text">
//             <h1 className="cs_hero_title cs_fs_94">{parse(title)}</h1>
//             <p className="cs_hero_subtitle cs_fs_20 cs_heading_color">
//               {parse(subTitle)}
//             </p>
//             <div className="cs_hero_btn_wrap">
//               <VideoModal
//                 videoUrl={videoUrl}
//                 videoBtnText={videoBtnText}
//                 variant="cs_heading_color"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }


function VideoModal({ url, onClose }) {
  // Convert youtube watch URL to embed
  const embedUrl = url
    ? url.replace("watch?v=", "embed/").replace("youtu.be/", "www.youtube.com/embed/") + "?autoplay=1"
    : "";
  useEffect(() => {
    const fn = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [onClose]);
  return (
    <div className="cbh-modal-bg" onClick={onClose}>
      <div className="cbh-modal" onClick={(e) => e.stopPropagation()}>
        <iframe src={embedUrl} allow="autoplay; fullscreen" allowFullScreen title="video" />
        <button className="cbh-modal__close" onClick={onClose}>✕</button>
      </div>
    </div>
  );
}

export default function BannerHero({
  bgUrl = "/images/about/banner_bg.jpg",
  title = "Advancing <em>Human</em><br/><strong>Health</strong> Forward",
  subTitle = "Celbion Healthcare delivers meaningful pharmaceutical solutions for patients and professionals across India.",
  videoUrl = "https://www.youtube.com/watch?v=-Ftg5mSK9LA",
  videoBtnText = "Watch Our Story",
}) {
  const [showModal, setShowModal] = useState(false);
  const dots = [0, 1, 2];
  const [activeDot, setActiveDot] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActiveDot((d) => (d + 1) % 3), 2500);
    return () => clearInterval(t);
  }, []);

  return (
    <>
      <div className="cbh-hero">
        <div className="cbh-hero__bg" style={{ backgroundImage: `url(${bgUrl})` }} />
        <div className="cbh-hero__overlay" />
        <div className="cbh-hero__scan" />
        <div className="cbh-hero__accent" />
        <div className="cbh-hero__orb cbh-hero__orb--a" />
        <div className="cbh-hero__orb cbh-hero__orb--b" />

        {/* Brand badge */}
        <div className="cbh-hero__brand">
          <span className="cbh-hero__brand-name">Celbion</span>
          <span className="cbh-hero__brand-sub">Healthcare</span>
        </div>

        {/* Side dots */}
        <div className="cbh-hero__dots">
          {dots.map((i) => (
            <span key={i} className={`cbh-hero__dot${activeDot === i ? " active" : ""}`} />
          ))}
        </div>

        <div className="cbh-hero__inner">
          <p className="cbh-hero__eyebrow">
            <span className="cbh-hero__eyebrow-line" />
            Trusted Pharmaceutical Partner
          </p>

          <h1
            className="cbh-hero__title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <span className="cbh-hero__rule" />

          <p
            className="cbh-hero__sub"
            dangerouslySetInnerHTML={{ __html: subTitle }}
          />

          {videoUrl && (
            <button className="cbh-video-btn" onClick={() => setShowModal(true)}>
              <span className="cbh-video-btn__circle">
                <svg viewBox="0 0 24 24"><polygon points="5,3 19,12 5,21" /></svg>
              </span>
              <span className="cbh-video-btn__text">
                <span className="cbh-video-btn__label">{videoBtnText}</span>
                <span className="cbh-video-btn__hint">2 min watch</span>
              </span>
            </button>
          )}
        </div>

        {/* Scroll hint */}
        <div className="cbh-hero__scroll">
          <span className="cbh-hero__scroll-text">Scroll</span>
          <span className="cbh-hero__scroll-line" />
        </div>
      </div>

      {showModal && <VideoModal url={videoUrl} onClose={() => setShowModal(false)} />}
    </>
  );
}

